module.exports = __webpack_public_path__ + "img/python.0f2b699f.png";